export default "__VITE_ASSET__BBNUeFDc__"